module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-can.3949bf8d.png";